import { useState, useEffect } from "react";
import { ModalApontamentosFiscais, ContainerTableApontamentosFiscais, ContainerTableAFiscais, ContainerControllers, ItemBtnExport, ContainerBusca } from "./styled";
import { ContainerSearch, ComponentTitle } from "../styledGlobalModal";
import axios from "axios";
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { toast } from 'react-toastify';
import CircularProgress from '@mui/material/CircularProgress';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Input, Switch, Select, Skeleton, DatePicker, ConfigProvider, Space, Tooltip } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import { SearchOutlined, EditOutlined, DownloadOutlined } from '@ant-design/icons';
import { CiSearch, CiLogout, CiEdit } from "react-icons/ci";
import listTables from "./tableTitles.json"
import {
    TableContainer,
    TableBody,
    TableRow,
    TableColumn,
    TableHeader,
    ColumnTitle,
    TableTitle,
    TableHead,
} from "../../../../CSSGlobal";
import { BtnBlue, } from "../../Modal/styledGlobalModal";
import { PaginationBtn } from "../../../../styledEvents";
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Pagination from '@mui/material/Pagination';
import dayjs from 'dayjs';
import ModalTratamentoFiscal from "./ModalTratamentoFiscal";
// import ModalTratamentoDp from "./ModalTratamentoDp";
// import ModalTratamento from "./ModalTratamento";


export function ApontamentosFiscais() {

    const [exporting, setExporting] = useState(false);
    const [isExcelAvailable, setIsExcelAvailable] = useState(true);
    const [clientParam, setClientParam] = useState("");
    const [titleTable, setTitleTable] = useState(listTables);
    const [showPendentes, setShowPendentes] = useState(true);
    const [pagePendentes, setPagePendentes] = useState(1);
    const [pageEmitidas, setPageEmitidas] = useState(1);
    const [totalPagesPendentes, setTotalPagesPendentes] = useState(0);
    const [totalPagesEmitidas, setTotalPagesEmitidas] = useState(0);
    const Numberpage = 5;
    const [listTableTarefasPendentes, setListTableTarefasPendentes] = useState([]);
    const [listTableTarefasEmitidas, setListTableTarefasEmitidas] = useState([]);

    const [showMessagePendentes, setShowMessagePendentes] = useState(false);
    const [showMessageEmitir, setShowMessageEmitir] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);
    const [loadingPendentes, setLoadingPendentes] = useState(false);
    const [loadingEmitidas, setLoadingEmitidas] = useState(false);
    const [isExportDisabled, setIsExportDisabled] = useState(true);
    const [reportType, setReportType] = useState("");
    const [apontamentoId, setApontamento] = useState("");
    const [isModalTratamento, setIsModalTratamento] = useState(false);
    const [toastsDisplayed, setToastsDisplayed] = useState(new Set());

    const [paramApontamento, setParamApontamento] = useState({
        isIdCliente: null,
        isCategoria: null,
        isAno: null,
        isMes: null,
        isSituacaoId: null
    })

    const [showTableTitle, setShowTableTitle] = useState(false);


    const monthFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
    const maskFormat = 'YYYY-MM';
    const [date, setDate] = useState(dayjs().format(monthFormat));

    const toastId = {
        successPendentes: 'successPendentes',
        successEmitidas: 'successEmitidas',
        error: 'error'
    };

    useEffect(() => {
        setDate(dayjs().format(monthFormat));
    }, []);

    useEffect(() => {
        let height = 1000;
        window.parent.postMessage({ frameHeight: height }, "*");
      },);

    const fetchData = async () => {
        const url = "/portal/rest/contador/fiscal/apontamento/pesquisar";
        const dataPendentes = {
            apontamentoFiscal: {
                dataReferencia: date,
                descricao: clientParam || null,
                situacao: {
                    id: "P"
                },
            },
            paginacao: { pagina: pagePendentes, tamanho: 5 }
        };
        const dataEmitidas = {
            apontamentoFiscal: {
                dataReferencia: date,
                descricao: clientParam || null,
                situacao: {
                    id: "F"
                },
            },
            paginacao: { pagina: pageEmitidas, tamanho: 5 }
        };

        setLoadingPendentes(true);
        setLoadingEmitidas(true);

        try {
            const [pendentesResponse, emitidasResponse] = await Promise.all([
                axios.post(url, dataPendentes, { withCredentials: true }),
                axios.post(url, dataEmitidas, { withCredentials: true })
            ]);

            if (Array.isArray(pendentesResponse.data.apontamentosFiscais)) {
                setListTableTarefasPendentes(pendentesResponse.data.apontamentosFiscais);
                setTotalPagesPendentes(pendentesResponse.data.paginacao.totalPaginas);
                setShowMessagePendentes(pendentesResponse.data.apontamentosFiscais.length === 0);


            }
            if (Array.isArray(emitidasResponse.data.apontamentosFiscais)) {
                setListTableTarefasEmitidas(emitidasResponse.data.apontamentosFiscais);
                setTotalPagesEmitidas(emitidasResponse.data.paginacao.totalPaginas);
                setShowMessageEmitir(emitidasResponse.data.apontamentosFiscais.length === 0);
            }

        } catch (error) {
            if (!toastsDisplayed.has(toastId.error)) {
                toast.error("Erro ao buscar os dados.");
                setToastsDisplayed(prev => new Set(prev).add(toastId.error));
            }
        } finally {
            setLoadingPendentes(false);
            setLoadingEmitidas(false);
        }
    };


    const exportToExcel = async (value) => {
        const excelUrl = `/portal/rest/contador/fiscal/apontamento/export/excel?report=${value}&termo=${clientParam}&dataReferencia=${date}`;

        try {
            setExporting(true);
            const response = await axios.get(excelUrl, {
                withCredentials: true,
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            let fileName = "";

            switch (value) {
                case "0":
                    fileName = 'planilha-controle-apontamentos-fiscais.xlsx';
                    break;
                case "2":
                    fileName = 'apontamentos-fiscais-detalhado.xlsx';
                    break;
            }

            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error('Erro ao exportar os dados:', error);
            toast.error('Erro ao exportar os dados, tente novamente em poucos minutos.');
        } finally {
            setExporting(false);
        }
    };

    const changeClientParam = (e) => {
        setClientParam(e.target.value);
        setInitialLoad(true);

    }

    const handleData = () => {
        fetchData();
        setShowTableTitle(true);
        setInitialLoad(true);
        setIsExportDisabled(false);
    }

    const handleToggleChange = (checked) => {
        setShowPendentes(!checked);
        setPageEmitidas(1);
        setPagePendentes(1);
        // setSearchTerm("");
    };

    const handleChangePagePendentes = (event, newPage) => {
        setPagePendentes(newPage);
    };

    const handleChangePageEmitidas = (event, newPage) => {
        setPageEmitidas(newPage);
    };

    const handleChange = (value) => {
        setReportType(value);
        exportToExcel(value);
    };

    const handleModalTratamento = async (id, mes, ano, idCliente, categoria, situacaoId) => {
        setIsModalTratamento(!isModalTratamento);
        setApontamento(id);
        await setParamApontamento(prevState => ({
            ...prevState,
            isMes: mes,
            isAno: ano,
            isIdCliente: idCliente,
            isCategoria: categoria,
            isSituacaoId: situacaoId
        }));
    }

    const onChangeValueDate = (dateValue, dateString) => {
        const formatDate = `${dateString}-15T00:00:00.000Z`;
        setDate(formatDate);
    };

    const handleDownload = async (mes, ano, idCliente) => {
        const url = `/portal/rest/contador/fiscal/apontamento/arquivos/download?id=${idCliente}&ano=${ano}&mes=${mes}`;

        setExporting(true);
        try {
            const response = await axios.get(url, {
                responseType: 'blob',
                withCredentials: true,
            });

            const contentType = response.headers['content-type'];
            const filename = `notasfiscais-${idCliente}.zip`;

            const blob = new Blob([response.data], { type: contentType || 'application/zip' });

            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            window.URL.revokeObjectURL(blobUrl);
            link.parentNode.removeChild(link);

        } catch (error) {
            toast.error("Não foi possível fazer o download do arquivo: " + error.message);
            setExporting(false);
        } finally {
            setExporting(false);
        }
    }

    const FloatButtonDownload = ({ tooltip }) => {
        return (
            <div className="float-button">
                <div className="button"><DownloadOutlined /></div>
                {/* <div className="tooltip-download">{tooltip}</div> */}
            </div>
        );
    };

    return (
        <ModalApontamentosFiscais>
            <ContainerTableApontamentosFiscais>
                <ContainerTableAFiscais>
                    <ContainerSearch>
                        <ContainerControllers>
                            <ComponentTitle>
                                <span>{"Apontamentos Fiscal"}</span>
                            </ComponentTitle>
                            {isExcelAvailable && (
                                <ItemBtnExport>
                                    {!exporting && (
                                        <>
                                            <div className="select-export">
                                                <Select
                                                    defaultValue="Exportar Excel"
                                                    style={{ width: 220, textAlign: "center" }}
                                                    onChange={handleChange}
                                                    className="select-excel"
                                                >
                                                    <Select.Option value="0">Excel - Controle Apontamentos ficais</Select.Option>
                                                    <Select.Option value="2" disabled={isExportDisabled}>
                                                        Excel - Apontamentos fiscais detalhados
                                                    </Select.Option>
                                                </Select>
                                            </div>
                                        </>
                                    )}
                                    {exporting && (
                                        <div>
                                            <CircularProgress
                                                className="cicleProgress"
                                                disableShrink
                                            />
                                        </div>
                                    )}
                                </ItemBtnExport>
                            )}
                        </ContainerControllers>
                    </ContainerSearch>
                    <ContainerBusca>
                        <Space direction="vertical">
                        <ConfigProvider locale={ptBR}>
                        <DatePicker
                                className="input-id"
                                defaultValue={dayjs(date, maskFormat)}
                                format={maskFormat}
                                picker="month"
                                style={{ width: "125px" }}
                                value={dayjs(date, maskFormat)}
                                onChange={onChangeValueDate}
                            />
                        </ConfigProvider>
                            
                        </Space>
                        <Input
                            placeholder="Cliente ID"
                            className="input-id"
                            value={clientParam}
                            onChange={changeClientParam}
                        />
                        <Button className="button-prox"
                            onClick={handleData}
                        >
                            <SearchOutlined />
                            Próximo
                        </Button>

                    </ContainerBusca>
                </ContainerTableAFiscais>
                {showTableTitle && (

                    <TableContainer>
                        <div className="checkbox-wrapper-34">
                            <Switch
                                checkedChildren="Emitidas"
                                unCheckedChildren="Pendentes"
                                defaultChecked
                                checked={!showPendentes}
                                onChange={handleToggleChange}
                            />
                        </div>

                        {showPendentes ? (
                            <>
                                {loadingPendentes ? (
                                    <Box sx={{ width: "100%" }}>
                                        <LinearProgress />
                                    </Box>
                                ) : null}
                                {loadingPendentes ? (
                                    <>
                                        {[...Array(2)].map((_, index) => (
                                            <Skeleton
                                                active
                                                key={index}
                                                variant="rectangular"
                                                width="100%"
                                                height={10}
                                                style={{ padding: "30px" }}
                                            />
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        {showTableTitle && (
                                            <TableHeader>
                                                <TableHead>
                                                    {titleTable[0].titles.map((item, index) => {
                                                        return (
                                                            <ColumnTitle key={index} id={index}>
                                                                <TableTitle>
                                                                    <span>{item.title}</span>
                                                                </TableTitle>
                                                            </ColumnTitle>
                                                        );
                                                    })}
                                                </TableHead>
                                            </TableHeader>
                                        )}

                                        <TableContainer>
                                            <TableBody>
                                                <>
                                                    {listTableTarefasPendentes.map((item, index) => (
                                                        <>
                                                            <TableRow key={index}>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.cliente.id}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.cliente.carteira.id}/{item.cliente.equipe.id}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.cliente.cnpj} <br />
                                                                        {item.cliente.nome}
                                                                    </span>
                                                                </TableColumn>

                                                                <TableColumn>
                                                                    <span>
                                                                        {item.ano}/{item.mes}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.categoria.nome}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.valor}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.situacao.id === "P" ? "Pendente" : "Fechado"}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <Button className="button-prox" onClick={() => handleModalTratamento(
                                                                        item.id,
                                                                        item.mes,
                                                                        item.ano,
                                                                        item.cliente.id,
                                                                        item.categoria.id,
                                                                        item.situacao.id
                                                                    )} >
                                                                        <CiLogout className="icon-btn" />
                                                                        Tratar
                                                                    </Button>
                                                                    <Tooltip title="Baixar arquivos">
                                                                        <div className="float-button-download" onClick={() => handleDownload(
                                                                            item.mes,
                                                                            item.ano,
                                                                            item.cliente.id,
                                                                        )}>
                                                                            <FloatButtonDownload />
                                                                        </div>
                                                                    </Tooltip>
                                                                </TableColumn>
                                                            </TableRow>
                                                        </>
                                                    ))}
                                                </>
                                                {showMessagePendentes && (
                                                    <div className="msgFilterSearch">
                                                        <Stack className="center" sx={{ width: "100%" }} spacing={2}>
                                                            <Alert severity="info">Nenhuma tarefa Pendente.</Alert>
                                                        </Stack>
                                                    </div>
                                                )}
                                            </TableBody>
                                            <PaginationBtn>
                                                <Stack spacing={1}>
                                                    <Pagination
                                                        count={Math.ceil(totalPagesPendentes / Numberpage)}
                                                        page={pagePendentes}
                                                        onChange={handleChangePagePendentes}
                                                        size="small"
                                                    />
                                                </Stack>
                                            </PaginationBtn>
                                        </TableContainer>
                                    </>
                                )}

                            </>
                        ) : (
                            <>
                                {loadingEmitidas ? (
                                    <Box sx={{ width: "100%" }}>
                                        <LinearProgress />
                                    </Box>
                                ) : null}
                                {loadingEmitidas ? (
                                    <>
                                        {[...Array(2)].map((_, index) => (
                                            <Skeleton
                                                active
                                                key={index}
                                                variant="rectangular"
                                                width="100%"
                                                height={10}
                                                style={{ padding: "30px" }}
                                            />
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        <TableHeader>
                                            <TableHead>
                                                {titleTable[1].titles.map((item, index) => {
                                                    return (
                                                        <ColumnTitle key={index} id={index}>
                                                            <TableTitle>
                                                                <span>{item.title}</span>
                                                            </TableTitle>
                                                        </ColumnTitle>
                                                    );
                                                })}
                                            </TableHead>
                                        </TableHeader>
                                        <TableContainer>
                                            <TableBody>
                                                <>
                                                    {listTableTarefasEmitidas.map((item, index) => (
                                                        <>
                                                            <TableRow key={index}>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.cliente.id}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.cliente.carteira.id}/{item.cliente.equipe.id}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.cliente.cnpj} <br />
                                                                        {item.cliente.nome}
                                                                    </span>
                                                                </TableColumn>

                                                                <TableColumn>
                                                                    <span>
                                                                        {item.ano}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.categoria.nome}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.valor}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <span>
                                                                        {item.situacao.id === "P" ? "Pendente" : "Fechado"}
                                                                    </span>
                                                                </TableColumn>
                                                                <TableColumn>
                                                                    <Button className="button-prox" onClick={() => handleModalTratamento(
                                                                        item.id,
                                                                        item.mes,
                                                                        item.ano,
                                                                        item.cliente.id,
                                                                        item.categoria.id,
                                                                        item.situacao.id
                                                                    )}>
                                                                        <EditOutlined className="icon-btn" />
                                                                        Editar
                                                                    </Button>
                                                                    <Tooltip title="Baixar arquivos">
                                                                        <div className="float-button-download" onClick={() => handleDownload(
                                                                            item.mes,
                                                                            item.ano,
                                                                            item.cliente.id,
                                                                        )}>
                                                                            <FloatButtonDownload />
                                                                        </div>
                                                                    </Tooltip>
                                                                </TableColumn>
                                                            </TableRow>
                                                        </>
                                                    ))}
                                                </>
                                                {showMessageEmitir && (
                                                    <div className="msgFilterSearch">
                                                        <Stack className="center" sx={{ width: "100%" }} spacing={2}>
                                                            <Alert severity="info">Nenhuma tarefa Emitida.</Alert>
                                                        </Stack>
                                                    </div>
                                                )}
                                            </TableBody>
                                            <PaginationBtn>
                                                <Stack spacing={1}>
                                                    <Pagination
                                                        count={Math.ceil(totalPagesEmitidas / Numberpage)}
                                                        page={pageEmitidas}
                                                        onChange={handleChangePageEmitidas}
                                                        size="small"
                                                    />
                                                </Stack>
                                            </PaginationBtn>
                                        </TableContainer>
                                    </>
                                )}

                            </>

                        )}
                    </TableContainer>
                )}
            </ContainerTableApontamentosFiscais>
            {isModalTratamento && (
                <ModalTratamentoFiscal
                    isOpen={isModalTratamento}
                    onClose={() => setIsModalTratamento(false)}
                    fetchPendentesData={fetchData}
                    fetchEmitidasData={fetchData}
                    idCliente={paramApontamento.isIdCliente}
                    id={apontamentoId}
                    categoria={paramApontamento.isCategoria}
                    ano={paramApontamento.isAno}
                    mes={paramApontamento.isMes}
                    situacaoId={paramApontamento.isSituacaoId}
                />
            )}
        </ModalApontamentosFiscais>
    );
}

export default ApontamentosFiscais;